import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
var KeyboardForbidden = _createClass(function KeyboardForbidden(player) {
    _classCallCheck(this, KeyboardForbidden);
    this.player = player;
    this.keyDownEvent = function (e) {
        if (player.focus) {
            var tag = document.activeElement.tagName.toUpperCase();
            var editable = document.activeElement.getAttribute('contenteditable');
            if (tag !== 'INPUT' && tag !== 'TEXTAREA' && editable !== '' && editable !== 'true') {
                var event = e || window.event;
                event.preventDefault();
                return;
            }
        }
    };
    this.player.template.playButton.removeEventListener('keydown', this.keyDownEvent);
    this.player.template.playButton.addEventListener('keydown', this.keyDownEvent);
});
export default KeyboardForbidden;